import React, { useCallback } from 'react'

import Padding from 'components/Editor/Toolbar/Padding'
import { LayoutScroll } from 'components/LayoutPage'
import { Typography } from 'components/uiKit/Typography'
import {
  BrandGoBack,
  BrandRichTextTypography,
  BrandRichTextFontForms,
} from 'services/Branding/components'
import { useElementFontCss, useElementFontValues } from 'services/Branding/hooks'
import { BrandFormEnum } from 'services/Branding/types'
import { t } from 'services/Translation'

import type { TestFeedbackFormBrandType, TestFeedbackBrandForms } from './testFeedbackTypes'

const TestFeedbackTypography: TestFeedbackFormBrandType = ({
  edited,
  device,
  element,
  setForm,
}) => {
  const { font } = element || {}
  const values = useElementFontValues('testFeedback', device, font)
  const styles = useElementFontCss('testFeedback', device, font)

  const goBack = useCallback(() => setForm?.(BrandFormEnum.STYLE), [setForm])

  return (
    <LayoutScroll sizeAutoCapable>
      <Padding bottomSpace gap sides>
        <BrandGoBack onClick={goBack}>
          <Typography weight='medium'>{t('page.brand.tab.typography')}</Typography>
        </BrandGoBack>
        <BrandRichTextTypography
          edited={edited.font}
          setActiveFont={setForm}
          styles={styles}
          values={values}
        />
      </Padding>
    </LayoutScroll>
  )
}

const FONTS_FORM_MAP: TestFeedbackBrandForms = {
  [BrandFormEnum.TYPOGRAPHY]: TestFeedbackTypography,
  ...BrandRichTextFontForms,
}

export default FONTS_FORM_MAP
